import React from 'react';
import './style.css';

export const SelectButton = ({ selected, children, onClick }) => {
  return (
    <button
      className={`select-button ${selected ? 'selected' : ''}`}
      onClick={onClick}
      type="button"
    >
      {children}
    </button>
  );
};